import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Badge.scss';

/**
 * Notification Badge
 * @class Badge
 * @extends {Component}
 */
class Badge extends Component {
  static propTypes = {
    /** Text displayed in the center of the badge */
    badgeText: PropTypes.string,
  };
  static defaultProps = { badgeText: '', };

  render() {
    return (
      <div
        id='Badge_link'
        className='badge'
        data-testid='badge'
        onClick={null}
      >
        {this.props.badgeText}
      </div>
    );
  }
}

export default Badge;
